import i18next from 'i18next'

export const required = (value) => (value ? undefined : i18next.t('Requerido'))
export const requiredSelect = (value) => (value?.length > 0 ? undefined : i18next.t('Requerido'))
export const email = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? i18next.t('Email invalido') : undefined
export const maxLength = (max) => (value) =>
  value && value.length > max ? i18next.t('maxCharacterValidation', { max: max }) : undefined
export const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce((error, validator) => error || validator(value), undefined)
